import { useUser } from '@myosh/myosh-login';
import { useStoredValue } from '@myosh/odin-components';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { useCallback } from 'react';
import { SCHEDULE_MODES, type ScheduleMode } from '@/utils/date-ranges';

const DEFAULT_MODE: ScheduleMode = 'month';

const modeParser = parseAsStringLiteral(SCHEDULE_MODES).withOptions({ history: 'replace', shallow: false });

const toMode = (value: string | null) => SCHEDULE_MODES.find((mode) => mode === value) ?? null;

// Like the filters, a launch without a mode param reopens the user's last view.
export const useScheduleMode = () => {
  const [urlMode, setUrlMode] = useQueryState('mode', modeParser);
  const { state } = useUser();
  const [storedMode, setStoredMode] = useStoredValue<ScheduleMode | null>({
    key: `scheduler:mode:${state.user?.preferred_username ?? ''}`,
    fromStored: toMode,
    toStored: (value) => value ?? '',
  });

  const setMode = useCallback(
    (next: ScheduleMode) => {
      void setUrlMode(next);
      setStoredMode(next);
    },
    [setUrlMode, setStoredMode]
  );

  return [urlMode ?? storedMode ?? DEFAULT_MODE, setMode] as const;
};
